<section class="main-loading" *ngIf="mainLoading">
  <!-- <mat-progress-spinner mode="indeterminate"> </mat-progress-spinner> -->
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</section>

<mat-sidenav-container [ngClass]="mainLoading ? 'blur-sm' : ''">
  <mat-sidenav #sidenav mode="push" class="sidenav" fixedInViewport="true" class="sidenav">
    <mat-toolbar> <span> Menu Principal </span></mat-toolbar>
    <mat-accordion>
      @for (item of menu; track item.title) {
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon class="mr-2">{{ item.icon }}</mat-icon>
            {{ item.title }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        @for (subMenu of item.subMenus; track subMenu.description) {
        <button (click)="goToPage(subMenu.route, sidenav)">
          {{ subMenu.description }}
        </button>
        }
      </mat-expansion-panel>
      }
    </mat-accordion>
  </mat-sidenav>

  <mat-sidenav-content>
    <mat-toolbar>
      <div class="flex">
        <button mat-icon-button aria-label="Icone do menu" matTooltip="Exibir menu" (click)="sidenav.toggle()">
          <mat-icon>menu</mat-icon>
        </button>
        <img src="../../app/core/assets/images/logo-planner-azul.png" (click)="redirectTransactions()" alt="logo"
          class="ml-4 w-32" style="cursor: pointer;" />
      </div>

      <div class="flex gap-4">
        <!-- <button
          mat-icon-button
          matBadge="8"
          matBadgePosition="after"
          matTooltip="Notificações"
          matTooltipClass="primary-tooltip"
        >
          <mat-icon>notifications</mat-icon>
        </button> -->

        <button mat-flat-button [matMenuTriggerFor]="perfil" aria-label="Menu do perfil"
          class="perfil w-full flex flex-col items-start text-left mt-4 sm:mt-0">
          <span class="block overflow-hidden text-ellipsis whitespace-nowrap w-full max-w-[10rem] sm:max-w-[20rem]">
            {{ nameUser }}
          </span>
          <mat-icon>keyboard_arrow_down</mat-icon>
        </button>

        <mat-menu #perfil="matMenu" xPosition="before">
          <button mat-menu-item (click)="goToProfile()">
            <mat-icon>person</mat-icon>
            <span>Perfil</span>
          </button>
          <button mat-menu-item (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span>Sair</span>
          </button>
        </mat-menu>
      </div>
    </mat-toolbar>

    <router-outlet class="content"></router-outlet>
    <!-- (emitMainLoading)="setMainLoading($event)" -->
  </mat-sidenav-content>
</mat-sidenav-container>